





import { Component, Vue } from 'vue-property-decorator';
import Icon from '@/components/common/icon.vue';
import { ConstantsModuleMapper } from '@/store/modules/constants';

const Mappers = Vue.extend({
  computed: {
    ...ConstantsModuleMapper.mapGetters(['chat']),
  },
});
@Component({
  components: {
    Icon,
  },
})
export default class DefaultChatButtonComponent extends Mappers {
  showChat() {
    const width = 600;
    const left = window.screen.width / 2 - width / 2;
    let chatUrl = this.$i18n.t(`${this.chat.url}`, this.$i18n.locale) as string;
    chatUrl = chatUrl.replaceAll('&amp;', '&');
    window.open(`${window.location.origin}${chatUrl}`, 'chat', `width=${width},height=600,top=0,left=${left}`);
    return false;
  }
}
